<template>
  <div class="Aboutus-area">
    <secBanner></secBanner>
    <el-container class="container content-area">
      <el-aside class="aside-area" width="260px">
        <ul>
          <li class="lead">解决方案</li>
          <li v-for="(item, index) in solution" :key="index">
            <router-link
              :to="{ name: 'solution', query: { id: item.id } }"
              :class="curArticle.id == item.id ? 'cur' : ''"
              >{{ item.title }}</router-link
            >
          </li>
        </ul>
      </el-aside>
      <div class="sub-content-area">
        <div class="breadcrumb-nav">
          您的位置：
          <!-- <router-link to="/" title="首页">首页</router-link>> -->
          <router-link
            :to="{ name: 'solution', query: { id: 22 } }"
            title="解决方案"
            >解决方案</router-link
          >
          <span>>&nbsp;{{ curArticle.title }}</span>
        </div>
        <div class="list">
          <ul class="dis_flex flex_wrap" v-viewer>
            <li class="imgli" v-for="(item, index) in list" :key="index">
              <div class="img">
                <img
                  :src="item.article_img"
                  :alt="item.title"
                  :title="item.title"
                />
              </div>
              <div class="text ellipsis">{{ item.title }}</div>
            </li>
          </ul>
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            layout="total, prev, pager, next, jumper"
            :hide-on-single-page="total < listQuery.limit"
            @pagination="getList"
          />
        </div>
      </div>
    </el-container>
  </div>
</template>
<script>
import secBanner from "@/components/assembly/sec-banner";
import Pagination from "@/components/assembly/pagination";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);
export default {
  data() {
    return {
      subnavs: [],
      baseurl: "",
      solution: [
        { title: "品牌企业解决方案", id: 22 },
        { title: "个体工商户解决方案", id: 25 },
        { title: "专卖连锁解决方案", id: 24 },
        { title: "公共食堂解决方案", id: 23 }
      ],
      newDetail: {},
      curArticle: { title: "品牌企业解决方案", id: 22 },
      total: 0,
      list: [],
      listQuery: {
        page: 1,
        limit: 12
      }
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.id) {
        this.solution.forEach(element => {
          if (Number(element.id) === Number(this.$route.query.id)) {
            this.curArticle = element;
          }
        });
        this.getList(this.$route.query.id);
      } else {
        this.curArticle = {};
      }
    }
  },
  mounted() {
    this.solution.forEach(element => {
      if (Number(element.id) === Number(this.$route.query.id)) {
        this.curArticle = element;
      }
    });
    this.getList(this.$route.query.id);
  },
  computed: {
    imgSrcList: function() {
      let imgsrc = [];
      this.list.filter(function(item) {
        imgsrc.push(item.article_img);
      });
      return imgsrc;
    }
  },
  methods: {
    getList(classifyidd) {
      this.$https
        .fetchPost("/Article/article_list", {
          classifyid: classifyidd,
          page: this.listQuery.page,
          limit: this.listQuery.limit
        })
        .then(response => {
          // console.log(response);
          this.total = response.data.count;
          this.list = response.data.data || [];
        });
    }
  },
  components: {
    secBanner,
    Pagination
  }
};
</script>
<style lang="less">
// .newdetail {
.newdetail-info {
  background: #ffffff;
  padding: 30px 0 100px;
  min-height: 50vh;
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 46px;
    letter-spacing: 0.9px;
    color: #2f3542;
    text-align: center;
    font-weight: bold;
  }
  .attr {
    margin: 30px 0;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #999999;
    text-align: center;
    span {
      display: inline-block;
      margin: 0 35px;
    }
  }
}
.list {
  padding: 50px 0;
  li.imgli {
    width: 283px;
    background-color: #ffffff;
    box-shadow: 0px 5px 5px 0px rgba(12, 3, 6, 0.05);
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 42px;
    &:not(:nth-child(3n)) {
      margin-right: 20px;
    }
    .img {
      width: 283px;
      height: 208px;
      border-radius: 6px;
      overflow: hidden;
      background-color: #ffffff;
      img {
        width: 100%;
        height: 100%;
        margin: 0 auto;
      }
    }
    .text {
      font-family: MicrosoftYaHei;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 32px;
      letter-spacing: 1px;
      color: #666666;
      padding: 10px 20px;
      text-align: center;
    }
  }
}
.newhtml {
  img {
    display: inline-block;
  }
  table {
    width: 100%;
  }
  * {
    max-width: 100%;
  }
}
// }
</style>



// WEBPACK FOOTER //
// src/components/solution/solution.vue